import PropTypes from 'prop-types';

const KkmNameLazy = ({ isLoaded, title }) => (isLoaded ? title : '...');

KkmNameLazy.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  showSubtitle: PropTypes.bool,
};

KkmNameLazy.defaultProps = {
  title: null,
  subTitle: null,
  showSubtitle: false,
};

export default KkmNameLazy;
